<template>
<div class="chapter">
<div class="inner_page">
<p class="p_toc_heading" id="tableofcontents">Table of Contents</p>
<p class="p_toc_entry_"><a href="#/OPS/section0001#auto_bookmark_toc_1">Blurb</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0003#auto_bookmark_toc_1">Realization</a></p>
<p class="p_toc_entry_"><span href="#/OPS/section0004#auto_bookmark_toc_1" title="Link target outside of Sample">Reconnaissance</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0005#auto_bookmark_toc_1" title="Link target outside of Sample">Recognition</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0006#auto_bookmark_toc_1" title="Link target outside of Sample">Risk</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0007#auto_bookmark_toc_1" title="Link target outside of Sample">Reward</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0008#auto_bookmark_toc_1" title="Link target outside of Sample">Recovery</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0009#auto_bookmark_toc_1" title="Link target outside of Sample">Resistance</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0010#auto_bookmark_toc_1" title="Link target outside of Sample">More from Ariel Tachna</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0011#auto_bookmark_toc_1" title="Link target outside of Sample">About the Author</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0012#auto_bookmark_toc_1" title="Link target outside of Sample">By Ariel Tachna</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0013" title="Link target outside of Sample">Visit Dreamspinner Press</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0014#auto_bookmark_toc_1" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?d8fc1268